function isKeycloakConfig(config) {
    return !!config.realm && !!config.client_id;
}
export const deriveAuthFromConfig = (config) => {
    if (isKeycloakConfig(config)) {
        const server = config.server ?? '';
        return {
            openID: {
                authentication: `${server}/auth/realms/${config.realm}/protocol/openid-connect/auth/`,
                token: `${server}/auth/realms/${config.realm}/protocol/openid-connect/token/`,
                logout: `${server}/auth/realms/${config.realm}/protocol/openid-connect/logout/`,
            },
            client_id: config.client_id,
        };
    }
    return undefined;
};
//# sourceMappingURL=deriveAuthFromConfig.js.map